import Image from 'next/image'
import Link from 'next/link'
import { FC, memo } from 'react'

import { BASE_URL } from '@/shared/lib/const/env'

import { AllAcsCatBlockProps } from '../../types'
import { CatListExtra } from '../cat-list-extra/cat-list-extra'

import cl from './style.module.scss'

export const CatListGrid: FC<AllAcsCatBlockProps> = memo(({ items }) => {
	return (
		<div className={cl.root}>
			{items?.map(item => {
				const main = item?.CATEGORIES?.slice(0, 7)
				const extra = item?.CATEGORIES?.slice(7)

				if (!(main?.length > 0)) return
				return (
					<ul key={item?.NAME} className={cl.list}>
						<p className={cl.title}>
							{item?.PICTURE && (
								<Image src={BASE_URL + item.PICTURE} alt={''} width={32} height={32} className={cl.img} />
							)}
							{item.NAME}
						</p>
						{main?.map(item => (
							<li key={item.NAME} className={cl.item}>
								{/*Добавил трим к ссылкам, потомучто они иногда приходят с проблелами и ссылка ломается */}
								<Link prefetch={false} href={item.LINK.trim()} className={cl.link}>
									{item.NAME}
								</Link>
							</li>
						))}
						<CatListExtra items={extra} />
					</ul>
				)
			})}
		</div>
	)
})
